import readingTime from "reading-time"

//calculates reading time in minutes from dynamic content

function getReadingTime(content) {
  if (!content || typeof content === "undefined") {
    return 0
  }
  return readingTime(content).minutes
}

export const calcReadingTime = (dynamicContent) => {
  let time = 0
  dynamicContent.map((block) => {
    switch (block.type) {
      case "wysiwyg":
        time += getReadingTime(block?.wysiwyg?.[0]?.text)
        break
      case "quotes":
        time += getReadingTime(block?.dynamic_headline)
        block.quotes.map((el) => {
          time += getReadingTime(el?.quote_text)
        })
        break
      case "headline_and_text":
        time += getReadingTime(block?.dynamic_headline)
        time += getReadingTime(block?.headlineAndTextText)
        break
      case "list":
        time += getReadingTime(block?.dynamic_headline)
        time += getReadingTime(block?.list_text)
        block.list.map((el) => {
          time += getReadingTime(el?.dynamic_headline)
          time += getReadingTime(el?.listElementText)
        })
        break
      case "facts":
        time += getReadingTime(block?.dynamic_headline)
        time += getReadingTime(block?.facts_description)
        block.facts.map((el) => {
          time += getReadingTime(el?.dynamic_headline)
          time += getReadingTime(el?.fact_description)
        })
        break
      case "divider_headline":
        time += getReadingTime(block?.dynamic_headline)
        break
      case "text_image":
        time += getReadingTime(block?.dynamic_headline)
        time += getReadingTime(block?.textImageText?.[0]?.text)
        break
      case "accordion":
        time += getReadingTime(block?.dynamic_headline)
        block.accordion.map((el) => {
          time += getReadingTime(el?.dynamic_headline)
          time += getReadingTime(el?.accordionitem_content)
        })
        break
      case "tools":
        time += getReadingTime(block?.dynamic_headline)
        block.toolsets.map((el) => {
          time += getReadingTime(el?.dynamic_headline)
          time += getReadingTime(el?.set_text)
        })
        break
      case "table_component":
        time += getReadingTime(block?.dynamic_headline)
        time += getReadingTime(block?.table_text)
      default:
        break
    }
  })
  return Math.max(1, Math.round(time))
}
